<template>
	<div>
		<new-page-gen :options="options" />
	</div>
</template>

<script>
import NewPageGen from './NewPageGen.vue'

const config = {
	options: {
		resource: 'summary-status-actions',
		navigateTo: 'edit',
		schemaModifier: async data => {
			data.autocompleteFields = [
				{
					name: 'clientId', // name of the field in jsonschema
					resource: 'clients',
					query: 'id',
					display: 'id' // field from response to be displayed in the suggestion
				}
			]
			return data
		}
	}
}

export default {
	name: 'SummaryStatusActionsNew',
	components: { NewPageGen },
	data: () => config
}
</script>
